import * as XLSX from 'xlsx'
import dayjs from 'dayjs'
import { createStandaloneToast } from '@chakra-ui/toast'

const { toast } = createStandaloneToast()
export const exportExcel = (List: any, headers: any, name: any) => {
  if (List.length < 1) {
    toast({
      description: 'please select item for export',
      status: 'error',
      duration: 5000,
      isClosable: true,
    })
  } else {
    // let first_worksheet = workbook.Sheets[workbook.SheetNames[0]];
    // let data = XLSX.utils.sheet_to_json(first_worksheet, {header:1});
    /* convert from array of arrays to workbook */
    const data = List.map((item: any) => {
      const head: any = []
      headers.forEach((x: any) => head.push(item[x.value]))
      return head
    })
    const head: any = []
    headers.forEach((x: any) => x.title !== 'Actions' && head.push(x.title))
    data.unshift(head)
    const worksheet = XLSX.utils.aoa_to_sheet(data)
    const newWorkbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(newWorkbook, worksheet, 'SheetJS')
    XLSX.writeFile(newWorkbook, `${name}_${dayjs().format('DD-MM-YYYY')}_timestamp.xlsx`)
  }
}
export const test = 'test'
